import React from "react";
import Rotas from "./routes";

function App() {
  document.title = 'Supliu Challenge'
  return (
    <Rotas/>
  );
}

export default App;
